export enum FileStatus {
  Complete = 'Complete',
  InProgress = 'In Progress',
  Error = 'Error',
  Cancel = 'Cancel',
}

export enum StorageUnit {
  Byte = 'B',
  Kilobyte = 'KB',
  Megabyte = 'MB',
  Gigabyte = 'GB'
}

export enum FileTypes {
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png',
  SVG = 'png',
  Webp = 'webp',
  Dcm = 'dcm',
}

export enum UploaderWorkerEnum {
  SetProfile = 'set profile',
  DeidDicom = 'deid dicom',
}
